var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['empty-wrapper', _vm.size]},[(_vm.imgSrc)?_c('img',{attrs:{"src":_vm.imgSrc,"alt":"no-data"}}):_c('img',{attrs:{"src":require("_images/patrol/no-data.png"),"alt":"no-data"}}),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }